import React, {useState} from "react";
import {useParams} from "react-router-dom";
import {FIELD_TYPE} from "../../../Type/Model/Model";
import {CustomTextField} from "../../../../../../components/CustomTextField";
import {CustomDatePicker} from "../../../../../../components/CustomDatePicker";
import CustomTimePicker from "../../../../../../components/CustomTimePicker";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import CustomPhotoPicker from "../../../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../../../Helpers/fileType";
import {toValidDate} from "../../../../../../Apis/functions";
import {CommonDocumentationFormApp} from "./CommonDocumentationFormApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const DocumentationFormRequestFormApp  = ({setPhotoPickerList,handleDeletePhotoPicker}) => {
    const [showBadgeMessage, setBadgeMessage] = useState(true);
    const { id, guardFlowId } = useParams();
    const { getBaseProps, fieldsFormCheckBox } = CommonDocumentationFormApp();

    const handleCloseBadge = () => {
        setBadgeMessage(false);
    }

    const fieldsForm = (field, data, handleChange, emptyFields, isValidData) => {
        const base = getBaseProps(field, emptyFields);
        const value = data[field.fieldId]?.value;
        const isValid = isValidData[field.fieldId];

        const fieldRenderers = {
            [FIELD_TYPE.TEXT.name]: () => (
                <CustomTextField
                    {...base}
                    length={FIELD_TYPE.TEXT.length}
                    trans={field.fieldName}
                    value={value ?? field?.value}
                    onChange={e => handleChange(field, e.target.value)}
                />
            ),
            [FIELD_TYPE.NUMERIC.name]: () => (
                <CustomTextField
                    {...base}
                    type="number"
                    length={FIELD_TYPE.NUMERIC.length}
                    trans={field.fieldName}
                    value={value || field?.value}
                    onChange={e => handleChange(field, e.target.value)}
                    inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    showCounter={true}
                    countDecimals={false}
                />
            ),
            [FIELD_TYPE.DATE.name]: () => {
                const dateValue = toValidDate(value) || toValidDate(field?.value) || null;

                return (
                    <CustomDatePicker
                        {...base}
                        trans={field.fieldName}
                        value={dateValue}
                        onChange={date => handleChange(field, date)}
                        openTo="day"
                        isValid={isValid}
                    />
                );
            },
            [FIELD_TYPE.TIME.name]: () => {
                const timeValue = value != null
                    ? new Date(1970, 0, 1, 0, 0, 0, value)
                    : field?.value instanceof Date
                        ? field.value
                        : null;

                return (
                    <CustomTimePicker
                        {...base}
                        title={field.fieldName}
                        value={timeValue}
                        handleChange={time => handleChange(field, time)}
                        actions={['accept', 'cancel']}
                        isValid={isValid}
                    />
                );
            },
            [FIELD_TYPE.DATE_TIME.name]: () => {
                const dateValue = toValidDate(value) || toValidDate(field?.value) || null;
                return (
                    <CustomDateTimePicker
                        {...base}
                        trans={field.fieldName}
                        value={dateValue || field?.value ? new Date(dateValue || field?.value) : null}
                        onChange={dateTime => handleChange(field, dateTime)}
                        isValid={isValid}
                    />
                )
            }
        };
        return fieldRenderers[field.fieldType]?.();
    };

    const fieldsFormDocument = (field, emptyFields) => {
        if (field.fieldType !== FIELD_TYPE.DOCUMENT.name) return null;

        return (
            <div className="mb-3">
                <p className={"fs-12px ibl-font-w-600 font-color-general-950 mb-16px"}>
                    {field?.fieldName}
                    {field?.required && <span className={"font-color-error-700"}> * </span>}
                </p>
                <CustomPhotoPicker
                    key={`${field.fieldId}-${JSON.stringify(field.value)}`}
                    id={`fu_${field.fieldId}`}
                    photoPicker={field?.value}
                    setPhotoPicker={(newValue) => {
                        setPhotoPickerList(prevList =>
                            prevList.map(item => {
                                if (item.fieldId === field.fieldId) {
                                    const updatedValue =
                                        typeof newValue === 'function' ? newValue(item.value) : {...item.value, ...newValue};
                                    return {
                                        ...item,
                                        value: updatedValue,
                                    };
                                }
                                return item;
                            })
                        );
                    }}
                    disabled={false}
                    actionModel={field?.value === null ? ACTION_MODEL.CREATE : ACTION_MODEL.UPDATE}
                    accept={{...FILE_TYPE.IMAGE_FILES_VIDEOS, size: FIELD_TYPE.DOCUMENT.length}}
                    titleInput={field.fieldName}
                    required={field.required}
                    showPreview={false}
                    classWith={'w-100'}
                    handleDelete={() => {
                        handleDeletePhotoPicker(field);
                    }}
                    emptyFields={field.required && emptyFields}
                />

            </div>
        );
    };

    return {
        guardFlowId,
        fieldsForm,
        fieldsFormDocument,
        fieldsFormCheckBox,
        setBadgeMessage,
        id,
        handleCloseBadge,
        showBadgeMessage
    };

}
